import comp from "./DetailJobView";
export default comp;
